<template>
    <template-generator-preview :layout="preview.Scheme">
        <div class="table-responsive mb-0">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th colspan="3" class="text-center bg-light-primary">Başlangıç</th>
                        <th colspan="3" class="text-center bg-light-success">Bitiş</th>
                        <th colspan="3" class="text-center bg-light-info">Tutar</th>
                    </tr>
                    <tr>
                        <th>İl</th>
                        <th>İlçe</th>
                        <th>Mahalle</th>
                        <th>İl</th>
                        <th>İlçe</th>
                        <th>Mahalle</th>
                        <th>Tır/Treyler (TL)</th>
                        <th>Kırkayak (TL)</th>
                        <th>Kamyon (TL)</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(route,index) in preview.Routes">
                        <tr :key="index">
                            <td>{{route.StartProvinceName || "-"}}</td>
                            <td>{{route.StartDistrictName || "-"}}</td>
                            <td>{{route.StartNeighbourhoodName || "-"}}</td>
                            <td>{{route.EndProvinceName || "-"}}</td>
                            <td>{{route.EndDistrictName || "-"}}</td>
                            <td>{{route.EndNeighbourhoodName || "-"}}</td>
                            <td>{{route.TreylerRoutePriceStr || "-"}}</td>
                            <td>{{route.KirkayakRoutePriceStr || "-"}}</td>
                            <td>{{route.KamyonRoutePriceStr || "-"}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </template-generator-preview>
</template>

<script>
import TemplateGeneratorPreview from '@/views/template-generator/components/TemplateGeneratorPreview.vue'
export default {
    components:{
        TemplateGeneratorPreview
    },
    props:{
        preview:Object
    }    
}
</script>